import { observable, makeObservable, action, runInAction } from 'mobx';
import { api } from '../../constants/apis';
import { deleteRequest, get, post } from '../../utils/axios-requests';

export default class HeaderUiStore {
  @observable error: string = '';
  @observable notifications: Array<any> = [];
  @observable context: any = null;
  @observable userCards: Array<any> = [];
  @observable user: any = null;

  constructor() {
    makeObservable(this);
  }

  @action
  public setError = (err: string) => {
    this.error = err;
  };

  @action
  public initliazeContext = (context: any) => {
    this.context = context;
  };

  @action
  public getNotifications = async () => {
    try {
      const res = await get(api.notifications.all);
      const res2 = await get(api.cards.user);

      runInAction(() => {
        this.notifications = res.data;
        this.userCards = res2.data;
      });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public getUserCode = async () => {
    try {
      const res = await get(api.users.all);

      runInAction(() => {
        this.user = res.data;
      });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public acceptRequest = async (noti: any, cardsSelected: Array<string>) => {
    try {
      const res = await post(
        api.connections.acceptRequest,
        {
          selectedProfiles: cardsSelected,
        },
        { requestId: noti._id }
      );

      await this.getNotifications();

      return res;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public deny = async (notiId: string) => {
    try {
      const res = await deleteRequest(api.connections.denyRequest, {
        requestId: notiId,
      });

      await this.getNotifications();

      return res;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };
}
